export default "__VITE_ASSET__5d659630__"